// extracted by mini-css-extract-plugin
module.exports = {"dp-dialog--footer":"dp-dialog--footer___fCzxW","dp-dialog--content":"dp-dialog--content___Uv6Tj","dp-dialog--cancel":"dp-dialog--cancel___MDOH-","dp-dialog":"dp-dialog___12P7L"};